import { createContext, useContext, type ReactNode } from 'react';

export type ProductTarget = 'auto' | 'habitational';

interface ProductTargetContextValue {
  productTarget: ProductTarget | null;
}

export const ProductTargetContext = createContext<ProductTargetContextValue>({
  productTarget: null,
});

interface ProductTargetProviderProps {
  productTarget: ProductTarget | null;
  children: ReactNode;
}

export const ProductTargetProvider = ({
  productTarget,
  children,
}: ProductTargetProviderProps) => {
  return (
    <ProductTargetContext.Provider value={{ productTarget }}>
      {children}
    </ProductTargetContext.Provider>
  );
};

export const useProductTarget = (): ProductTarget | null => {
  const context = useContext(ProductTargetContext);
  return context.productTarget;
};
